export const sweep = "R_a";
export const undoCommandingBar = "S_a";
export const previousLabel = "T_a";
export const nextLabel = "U_a";
export const closeLabel = "V_a";
export const customizeToolbar = "W_a";
export default {sweep,undoCommandingBar,previousLabel,nextLabel,closeLabel,customizeToolbar};